import React, { useRef, useState } from "react";
import { FaTrashAlt } from "react-icons/fa";
import { useDispatch } from "react-redux";
// import { deleteCover } from "./../../../redux/slice/policy/policySlice";
import SelectCover from "../../../modals/policy/SelectCover";
import { flashMessage as flash } from "../../../../utils/flash";
import { useSelector } from "react-redux";
import SelectLifeCover from "../../../modals/policy/SelectLifeCover";
import MultiSelect from "../../../form/select/MultiSelect";


const multipleData = [
  { name: 'Total Contribution', id: 'total contribution'},
  { name: 'Savings Balance', id: 'savings balance'},
]


// export const filterMultiple = (multipleData, multiple_value) => {
//   return multipleData
//     ?.filter((item, i) =>
//       multiple_value?.some(
//         (data) => item?.id === data.id
//       )
//     )
//     .map((value) => ({
//       label: value?.name,
//       value: value.id,
//     }));
//   };
  const Cover = ({ values, setFieldValue, edit, handleChange, errors, touched, handleBlur, getFieldProps }) => {
    const { cover } = useSelector((state) => state.policy);
    const { unpaginated_life_cover } = useSelector((state) => state?.lifecover);

    const multiRef = useRef(null);
    
  const handleCoverChange = (selected) => {
    if (values.cover?.some((item) => parseInt(item) === selected?.value)) {
      flash("error", "Already in the cover list");
      return;
    }
    setFieldValue(`cover`, [...values?.cover, selected?.value]);
  };

  const handleLifeChange = (selected) => {
    if (values.lifeCover?.some((item) => parseInt(item) === selected?.value)) {
      flash("error", "Already in the life cover list");
      return;
    }
    setFieldValue(`lifeCover`, [...values?.lifeCover, selected?.value]);
  };

  const dispatch = useDispatch();

  const DeleteCover = (e, i) => {
    const covers = [...values?.cover];
    if ("id" in covers) return;
    covers.splice(i, 1);
    setFieldValue("cover", covers);
    // dispatch(deleteCover({ id }));
  };

  const DeleteLifeCover = (e, i) => {
    const covers = [...values?.lifeCover];
    if ("id" in covers) return;
    covers.splice(i, 1);
    setFieldValue("lifeCover", covers);
    // dispatch(deleteCover({ id }));
  };

  return (
    <div>
      <h5 className='text-primary-1 mt-1'>LIFE COVER TYPE</h5>

      <div>
        {values?.lifeCover?.map((item, i) => {
          const coverDisplay = unpaginated_life_cover?.find(
            (cover) => cover.id == item
          );

          return (
            <div
              className='mb-2 shadow-sm p-2 d-flex justify-content-start'
              key={i}
            >
              {/* <b className='me-1'>{i + 1}. </b> */}
              <div className='d-flex justify-content-between w-100'>
                <span className='text-capitalize'>
                  {coverDisplay?.life_cover_name}
                </span>
                {edit ? (
                  <span
                    className='ms-3 cursor-p'
                    onClick={(e) => DeleteLifeCover(e, i)}
                  >
                    <FaTrashAlt size={12} className='text-danger' />
                  </span>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
      {edit && (
        <div className='col-md-12 mb-3'>
          {values?.lifeCover >= 1 ? null : (
            <div className='col-md-12 mb-3'>
              <button
                type='button'
                className='btn btn-primary btn-sm'
                data-bs-toggle='modal'
                data-bs-target='#select-life-cover'
              >
                <i className='mdi mdi-plus me-1'></i>
                <span>Add</span>
              </button>
            </div>
          )}
        </div>
      )}
      <h5 className='text-primary-1 mt-3 upper-text'>LIFE COVER CLAIMS</h5>
      {!edit ? <div>
        {values?.life_cover_claim_name === "multiple" && <span>Multiple</span>}
        {values?.life_cover_claim_name === "multiple" && <div>
          {values?.multiple_value?.map(
              (item, i) => (
              <span
                  className='bg-primary text-light fs-6'
                  style={{ padding: "4px", margin: "0px 4px" }}
                  key={i}
              >
                  {item.label}
              </span>
              )
          )}
        </div>}
        {values?.life_cover_claim_name === "assumed" && <p>Assumed Sum Assured</p>}
        {values?.life_cover_claim_name === "guaranteed" && <p>Guaranteed Sum Assured</p>}
        {values?.life_cover_claim_name === "guaranteed" && <div className='mt-1 mb-1'>
            <strong>Guaranteed Type: </strong>
            <span>{values?.assumed_garranty_type === 'fixed' ? "Fixed" : "Range"}</span>
        </div>}
        {values?.life_cover_claim_name === "guaranteed" && <div>
          {values?.assumed_garranty_type === 'fixed' ? <div className='mt-1 mb-1 col-md-6'>
            <p>{values?.assumed_garranty_value}</p>
          </div> : 
          <div className="row">
            <div className="col-md-6">
              <label htmlFor='' className='form-labe mt-1'>
                Min.
              </label>
              <p>{values?.assumed_garranty_minimum}</p>
            </div>
            <div className="col-md-6">
              <label htmlFor='' className='form-labe mt-1'>
                Max.
              </label>
              <p>{values?.assumed_garranty_maximum}</p>
            </div>
          </div>
          }
        </div>}
      </div> : null}
      {edit ? <div className="mb-2">
        <div class='form-check my-1'>
          <input
          class='form-check-input mx-1'
          type='radio'
          name='life_cover_claim_name'
          id='life_cover_claim_name'
          value='multiple'
          onChange={handleChange}
          defaultChecked={values?.life_cover_claim_name === "multiple"}
          />
          <label class='form-check-label' for='company_wide'>
              Multiple
          </label>
          {values?.life_cover_claim_name === "multiple" && (
                <div className='ms-3 my-1'>
                    <MultiSelect
                    isError={
                        errors?.multiple_value
                    }
                    name='multiple_value'
                    field={{ ...getFieldProps("multiple_value") }}
                    data={multipleData?.map((item, i) => ({
                        label: item?.name,
                        value: item?.id,
                    }))}
                    onChange={setFieldValue}
                    onBlur={() => {
                        handleBlur({ target: { name: "multiple_value" } });
                    }}
                    defaultValue={values.multiple_value}
                    errors={errors}
                    touched={touched}
                    disabled={values?.life_cover_claim_name !== "multiple"}
                    ref={multiRef}
                    />
                </div>
            )}
        </div>
        <div class='form-check my-1'>
            <input
            class='form-check-input mx-1'
            type='radio'
            name='life_cover_claim_name'
            value='assumed'
            onChange={handleChange}
            id='life_cover_claim_name'
            defaultChecked={values?.life_cover_claim_name === "assumed"}
            />
            <label class='form-check-label' for='rab'>
                Assumed Sum Assured
            </label>
        </div>
        <div class='form-check my-1'>
            <input
            class='form-check-input mx-1'
            type='radio'
            name='life_cover_claim_name'
            value='guaranteed'
            onChange={handleChange}
            id='life_cover_claim_name'
            defaultChecked={values?.life_cover_claim_name === "guaranteed"}
            />
            <label class='form-check-label' for='rab'>
                Guaranteed Sum Assured
            </label>
        </div>
        {values?.life_cover_claim_name === "guaranteed" && <div className="ms-3">
          <div class='form-check my-1'>
            <input
            class='form-check-input mx-1'
            type='radio'
            name='assumed_garranty_type'
            value='fixed'
            onChange={handleChange}
            id='assumed_garranty_type'
            defaultChecked={values?.assumed_garranty_type === "fixed"}
            />
            <label class='form-check-label' for='rab'>
              Fixed Value
            </label>
          </div>
          {values?.assumed_garranty_type === 'fixed' && 
            <div className='ms-4'>
              <input
                type='number'
                className='form-control form-control-sm'
                id='assumed_garranty_value'
                name='assumed_garranty_value'
                value={values?.assumed_garranty_value}
                onChange={handleChange}
              />
              {errors?.assumed_garranty_value && touched?.assumed_garranty_value && (
                <span className='text-danger'>{errors?.assumed_garranty_value}</span>
              )}
            </div>
          }
          <div class='form-check my-1'>
            <input
            class='form-check-input mx-1'
            type='radio'
            name='assumed_garranty_type'
            value='range'
            onChange={handleChange}
            id='assumed_garranty_type'
            defaultChecked={values?.assumed_garranty_type === "range"}
            />
            <label class='form-check-label' for='rab'>
              Range
            </label>
          </div>
          {values?.assumed_garranty_type === 'range' && 
            <div className="row ms-4">
              <div className="col-md-6 d-flex flex-row gap-2">
                <label className="">Min</label>  
                <input
                  type='number'
                  className='form-control form-control-sm'
                  id='assumed_garranty_minimum'
                  name='assumed_garranty_minimum'
                  value={values?.assumed_garranty_minimum}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6 d-flex flex-row gap-2">
                <label className="">Max</label>  
                <input
                  type='number'
                  className='form-control form-control-sm'
                  id='assumed_garranty_maximum'
                  name='assumed_garranty_maximum'
                  value={values?.assumed_garranty_maximum}
                  onChange={handleChange}
                />
              </div>
              {errors?.assumed_garranty_maximum && touched?.assumed_garranty_maximum && (
                <span className='text-danger'>{errors?.assumed_garranty_maximum}</span>
              )}
            </div>
          }
        </div>}
      </div> : null}

      {(edit || values?.cover?.length > 0 ) && <h5 className='text-primary-1 mt-2'>OTHER COVER TYPE</h5>}
      <div>
        {values?.cover?.map((item, i) => {
          const coverDisplay = cover?.saving_covers?.find(
            (cover) => cover.id == item
          );
          return (
            <div
              className='mb-2 shadow-sm p-2 d-flex justify-content-start'
              key={i}
            >
              <b className='me-1'>{i + 1}. </b>
              <div className='d-flex justify-content-between w-100'>
                <span className='text-capitalize'>
                  {coverDisplay?.cover_name}
                </span>
                {edit ? (
                  <span
                    className='ms-3 cursor-p'
                    onClick={(e) => DeleteCover(e, i)}
                  >
                    <FaTrashAlt size={12} className='text-danger' />
                  </span>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
      {edit && (
        <div className='col-md-12 mb-3'>
          <div className='col-md-12 mb-3'>
            <button
              type='button'
              className='btn btn-primary btn-sm'
              data-bs-toggle='modal'
              data-bs-target='#select-cover'
            >
              <i className='mdi mdi-plus me-1'></i>
              <span>Add</span>
            </button>
          </div>
        </div>
      )}

      <SelectCover modal_id={"select-cover"} handleChange={handleCoverChange} />
      <SelectLifeCover
        modal_id='select-life-cover'
        handleChange={handleLifeChange}
        // covers={lifeData}
      />
    </div>
  );
};

export default Cover;
